import { useQuery } from '@tanstack/react-query'
import { TwoFATypes } from 'pages/MyAccountEdit/types'
import { postRequest } from 'utils/api/apiRequest'

type GeneratedCodeChallenge = {
  code_challenge: string
  secret: string
}

const post = (type: TwoFATypes) =>
  postRequest<GeneratedCodeChallenge>(`/2fa/generate-code-challenge`, {
    type,
  })

export const usePostGenerateCodeChallenge = (qrCode: string | null, type: TwoFATypes) => {
  const hasQrCode = !!qrCode
  return useQuery({
    // @ts-ignore
    enabled: hasQrCode,
    queryKey: ['generateCodeChallenge', `hasQrCode-${hasQrCode}`],
    queryFn: () => post(type),
    gcTime: 100,
    staleTime: 100,
  })
}
